import React, {Component} from 'react';
import ReactTable from 'react-table';
import {Button, Card, CardBody, Form, Input,} from 'reactstrap';
import {I18n} from '../../I18n/components/linkedCompaniesList';
import profilephoto from '../../assets/images/users/1.jpg';

import 'react-table/react-table.css';
import './linkedCompaniesList.css';

import {COMPANIESMODALVIEWS} from '../../helpers/constants';
import {connect} from "react-redux";

class LinkedCompaniesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      filteredCompanies: []
    }
  }

  componentDidMount() {
    let companies = [];
     this.props.attributeCompanies.forEach(item => {
        const company = this.props.companies.filter(company => company.id === item);
        if (company.length) {
          companies.push(company[0]);
        }
    });
    this.setState({
      companies: companies,
      filteredCompanies: companies
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.attributeCompanies !== prevProps.attributeCompanies) {
      let companies = [];
      this.props.attributeCompanies.forEach(item => {
        const company = this.props.companies.filter(company => company.id === item);
        if (company.length) {
          companies.push(company[0]);
        }
      });
      this.setState({
        companies: companies,
        filteredCompanies: companies
      })
    }
  }

  onFilterClick = event => {
    const filterWord = event.target.value;
    let filtered = [];
    if (filterWord) {
      filtered = this.state.companies.filter(item =>
        item.name.toLowerCase().indexOf(filterWord.toLowerCase()) !== -1);
    } else {
      filtered = this.state.companies;
    }
    this.setState({
      filteredCompanies: filtered
    })
  };

    render() {
      const {lang} = this.props;
      const {filteredCompanies, companies} = this.state;
      return (
        <Card className='companieslist '>
          <CardBody>
            <div className="companies-card">
              <Form className="companies-searchform">
                <Input
                    type="text"
                    name="companiesSearch"
                    id="companiesSearch"
                    onChange={this.onFilterClick}
                    placeholder={I18n[lang].searchPlaceholder}
                />
              </Form>
            </div>
            {
              (() => {
                let firstElementNumber = 1;
                const tableData = filteredCompanies.map((company, index) => {
                  return {
                    count_id: firstElementNumber++,
                    id: company.id,
                    name: company.name,
                    actions: (
                      <div className="text-center ">
                        {
                          this.props.view !== COMPANIESMODALVIEWS.VIEW ? (
                              <Button
                                  title={I18n[lang].delete}
                                  onClick={() => {
                                    this.props.removeCompanies(company)
                                  }}
                                  className="ml-1 companieslist-card__btn"
                                  color="danger"
                                  size="sm"
                                  round="true"
                                  icon="true"
                              >
                                <i className="fa fa-times"/>
                              </Button>
                          ) : ""
                        }
                      </div>
                    ),
                    companyData: company
                  };
                });
                return (
                    <div className="companies-table">
                        <ReactTable
                          getProps={(state, rowInfo, column, instance) => {
                            return {
                              style: {
                                  border: "none",
                                  padding: "5px"
                              }
                            };
                          }}
                            getTheadProps={(state, rowInfo, column, instance) => {
                                return {
                                    style: {
                                        boxShadow: "none",
                                        padding: "10px 0",
                                        fontWeight: "600"
                                    }
                                };
                            }}
                            getTheadThProps={(state, rowInfo, column, instance) => {
                                return {
                                    style: {
                                        borderRight: "none"
                                    }
                                };
                            }}
                            getTdProps={(state, rowInfo, column, instance) => {
                                return {
                                    style: {
                                        borderRight: "none",
                                        textAlign: "center"
                                    }
                                };
                            }}
                            getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    style: {
                                        alignItems: "center"
                                    }
                                };
                            }}
                            getNoDataProps={(state, rowInfo, column, instance) => {
                                return {
                                    style: {
                                        top: "100%"
                                    }
                                };
                            }}
                            columns={[
                                {
                                    Header: "#",
                                    accessor: "count_id",
                                    sortable: false,
                                    filterable: false,
                                    style: {
                                        textAlign: "left",
                                        fontSize: "0.7rem",
                                        textTransform: "lowercase"
                                    },
                                    maxWidth: 40,

                                },
                                {
                                    Header: `${I18n[lang].companyName}`,
                                    accessor: "name",
                                    sortable: false,
                                    filterable: false,
                                    minWidth: 200,
                                    style: {
                                        fontSize: "1.2rem",
                                        textAlign: "left"
                                    },
                                    Cell: row => (
                                        <div className="companies-table__img">
                                            <img
                                                src={row.value && row.value.img ? row.value.img : profilephoto}
                                                alt="company"
                                                className="rounded-circle"
                                                width="60"
                                            />
                                            <span>{row.value}</span>
                                        </div>
                                    )
                                },
                                {
                                    Header: "",
                                    accessor: "actions",
                                    sortable: false,
                                    filterable: false,
                                    maxWidth: 150
                                }
                            ]}
                            defaultPageSize={-1}
                            pageSize={tableData.length}
                            showPaginationBottom={false}
                            className="-highlight"
                            data={tableData}
                            filterable
                        />
                    </div>
                )
              })()
            }
          </CardBody>
        </Card>
      )
    }
}

const mapDispatchToProps = dispatch => {
  return {
  };
};

const mapStateToProps = state => ({
  lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkedCompaniesList)



// WEBPACK FOOTER //
// ./src/components/LinkedCompaniesList/LinkedCompaniesList.js